var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('SiteHeader',{attrs:{"menu-items":_vm.menuItems},on:{"search":_vm.onSearch,"quote":_vm.onQuote}}),_c('router-view'),_c('SiteFooter',{on:{"contact":_vm.onContact}}),_c('ContactSidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }